import React from 'react';
import { Chip, styled, CircularProgress } from '@mui/material';

interface RiskChipProps {
  riskLevel: string | null | undefined;
  size?: 'small' | 'medium';
}

const StyledRiskChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'riskLevel',
})<{ riskLevel: string }>(({ riskLevel }) => ({
  backgroundColor: 
    riskLevel === 'high' ? '#FEE4E2' : 
    riskLevel === 'medium' ? '#FEF0C7' : 
    riskLevel === 'low' ? '#D1FADF' :
    '#F3F4F6', // Gray for unknown
  color: 
    riskLevel === 'high' ? '#B42318' : 
    riskLevel === 'medium' ? '#B54708' : 
    riskLevel === 'low' ? '#027A48' :
    '#6B7280', // Gray for unknown
  fontWeight: 600,
  fontSize: '12px',
  height: '24px',
  textTransform: 'capitalize',
  '&:hover': {
    backgroundColor: 
      riskLevel === 'high' ? '#FEE4E2' : 
      riskLevel === 'medium' ? '#FEF0C7' : 
      riskLevel === 'low' ? '#D1FADF' :
      '#F3F4F6', // Gray for unknown
  },
}));

export const RiskChip: React.FC<RiskChipProps> = ({ riskLevel, size = 'small' }) => {
  const normalizedRiskLevel = riskLevel?.toLowerCase() || 'unknown';
  
  // If risk analysis is running, show a loading state
  if (riskLevel === 'RUNNING' || riskLevel === 'PENDING') {
    return (
      <Chip
        label={riskLevel === 'RUNNING' ? 'Analyzing...' : 'Pending'}
        size={size}
        icon={<CircularProgress size={14} sx={{ color: '#6B7280' }} />}
        sx={{
          backgroundColor: '#F3F4F6',
          color: '#6B7280',
          fontWeight: 600,
          fontSize: '12px',
          height: '24px',
          '& .MuiChip-icon': {
            marginLeft: '4px',
            marginRight: '-2px'
          }
        }}
      />
    );
  }
  
  return (
    <StyledRiskChip
      label={normalizedRiskLevel}
      size={size}
      riskLevel={normalizedRiskLevel}
    />
  );
};

export default RiskChip;